import React from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import "../assets/styles/Footer.scss";

function Footer({ parentToChild }: { parentToChild?: { mode: string } }) {
  const mode = parentToChild?.mode || "dark";

  return (
    <Box
      component="footer"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "4rem 1rem",
        textAlign: "center",
        backgroundColor: "transparent",
      }}
    >
      <Typography
        variant="body2"
        component="p"
        sx={{
          fontSize: { xs: "0.8rem", sm: "0.9rem" },
          color:
            mode === "dark"
              ? "rgba(255, 255, 255, 0.7)"
              : "rgba(13, 17, 22, 0.7)",
          mt: "auto",
        }}
      >
        This portfolio was created using React by Danjel Frrokaj
      </Typography>
    </Box>
  );
}

export default Footer;
